export default __webpack_public_path__ + "static/media/BubblesStep1.e2d3a962.png";